import BlogTagsList from "./BlogTagsList";
import BlogTagsCreate from "./BlogTagsCreate";
import BlogTagsEdit from "./BlogTagsEdit";

export default {
    list: BlogTagsList,
    create: BlogTagsCreate,
    edit: BlogTagsEdit
};